import { Button } from '../components/Button';
import background from '../assets/background.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSubscriptionTerms } from '../components/terms/AcceptanceTerms';
import { NotificationTerms } from '../components/terms/NotificationTerms';
import DotSpinner from '../components/shared/DotSpinner';
import { useEffect, useState } from 'react';
import config from '../config';

export default function HomePage() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const { CheckBox, isChecked } = useSubscriptionTerms();

  const handleStart = () => {
    if (!isChecked)
      return toast.info('Пожалуйста, подтвердите согласие с правилами сервиса и обработкой данных под кнопкой');
    navigate('/menu');
  };

  useEffect(() => {
    const steps = location.state?.steps || [];

    if (steps.length > 0) {
      navigate(config.ROUTES.CALCULATE, { state: { steps } });
    } else {
      setIsLoading(false);
    }
  }, [location]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[100vh] [background:linear-gradient(180deg,rgb(1,13,13)_0%,rgb(3.01,42.5,42.5)_100%)] bg-[100%_100%] bg-repeat-y bg-cover">
        <DotSpinner />
      </div>
    );
  }

  return (
    <div className="relative w-[100%] h-[100%] overflow-x-hidden overflow-y-hidden">
      <img src={background} alt="" className="absolute w-[100vw] z-0" />
      <div className="z-20 flex flex-col justify-center items-center w-[100%] mt-10">
        <img src="/logo1.svg" alt="" className="z-20" />
        <div className="z-20 w-[343px] mt-[30px] font-medium text-textmain text-[28px] text-center font-raleway text-white">
          Счастье пахнет мятой
        </div>
        <p className="z-20 text-white w-[343px] mt-[15px] font-raleway font-normal text-lg text-center">
          Расскажи о себе – это поможет создать профиль и сразу начать общаться
        </p>
        <div className="absolute bottom-4 right-4 left-4 pointer-events-none">
          <Button
            onClick={handleStart}
            id="jnl7j4km1wh"
            className={`pointer-events-auto w-full ${!isChecked && 'opacity-30'}`}
          >
            Начать
          </Button>

          <CheckBox />
          <NotificationTerms />
        </div>
      </div>
    </div>
  );
}
